import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import {
  isAdmin,
  isModerator,
  isProductManager,
  isSalesManager,
  isSalesRep,
  canAccessMagazine,
  canAccessOpsNav,
  canAccessCompanies,
  canEditCompanies,
  canEditContacts,
  canEditAnyDeal,
  canManageMagazineCatalog,
  canViewMagazineReports,
  canViewSalesReports,
  canManageUsers,
} from '../util/roles';
import { can, Permission } from '../util/permissions';

export const useAuth = () => {
  const { user, dispatch } = useContext(AuthContext);

  return {
    user,
    dispatch,
    isAdmin: isAdmin(user),
    isModerator: isModerator(user),
    isProductManager: isProductManager(user),
    isSalesManager: isSalesManager(user),
    isSalesRep: isSalesRep(user),
    canAccessMagazine: canAccessMagazine(user),
    canAccessOpsNav: canAccessOpsNav(user),
    canAccessCompanies: canAccessCompanies(user),
    canEditCompanies: canEditCompanies(user),
    canEditContacts: canEditContacts(user),
    canEditAnyDeal: canEditAnyDeal(user),
    canManageMagazineCatalog: canManageMagazineCatalog(user),
    canViewMagazineReports: canViewMagazineReports(user),
    canViewSalesReports: canViewSalesReports(user),
    canManageUsers: canManageUsers(user),
    can: (permission: Permission) => can(user, permission),
  };
};
